"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I8N_1 = require("./I8N");
require("moment/locale/ar");
require("moment/locale/en-gb");
var moment = require("moment");
function formatDate(date, format, forceLocale) {
    if (forceLocale) {
        return moment(date).locale(forceLocale).format(format);
    }
    return moment(date).locale(I8N_1.default.locale()).format(format);
}
exports.formatDate = formatDate;
function parseDate(dateString, format, forceLocale) {
    if (forceLocale) {
        return moment(dateString, format, forceLocale).toDate();
    }
    else {
        return moment(dateString, format, I8N_1.default.locale()).toDate();
    }
}
exports.parseDate = parseDate;
function toServerDate(date) {
    return formatDate(date, "YYYY-MM-DDTHH:mm:ss.SSSSSSSZ", "en");
}
exports.toServerDate = toServerDate;
function serverDateToDate(dateString) {
    if (dateString) {
        var format = "YYYY-MM-DDTHH:mm:ss.SSSSSSSZ";
        if (dateString.length === 19) {
            format = "YYYY-MM-DDTHH:mm:ss";
        }
        return parseDate(dateString, format, "en");
    }
    return undefined;
}
exports.serverDateToDate = serverDateToDate;
function toServerDateMinimal(date) {
    if (date) {
        return formatDate(date, "YYYY-MM-DDTHH:mm:ss", "en");
    }
    return undefined;
}
exports.toServerDateMinimal = toServerDateMinimal;
function normatizeDate(date) {
    var d = new Date(date.getTime());
    d.setHours(0, 0, 0, 1);
    return d;
}
exports.normatizeDate = normatizeDate;
//# sourceMappingURL=DateTime.js.map